import Vue from 'vue';
import moment from 'moment';

const pickerDateFormat = 'YYYY-M-D';
const uiDateFormat = 'DD/MM/YYYY';

export default {
  name: 'Manpower',
  components: {
    TimeComp: require('../../../components/time.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appData: {
        employee: { fullname: '' },
        stations: [],
        scheduledDateTime: new Date(),
        endDateTime: new Date(),
      },
      showDate: { scheduledDateTime: false },
      disabledDates: date => {
        return (date < this.appData.startDateTime) || (date > this.appData.endDateTime);
      },
      stationId: 0,
      allEmployees: [],
      scheduledDateTime: {},
      scheduledTime: { hours: 0, minutes: 0, descr: 'manpowers.ScheduledTime', isReadOnly: false },
    }
  },
  computed: {
    employee: function () {
      return this.appData.employee;
    },
    scheduledTimeHours: function () {
      return this.scheduledTime.hours;
    },
    scheduledTimeMinutes: function () {
      return this.scheduledTime.minutes;
    },
  },
  watch: {
    stationId: function (value) {
      this.appData.availableEmployees = (this.stationId < 1) ? this.allEmployees : this.allEmployees.filter(item => item.stationId == this.stationId);
    },
    employee: function (value) {
      if (value.employeeId && this.$refs.select)
        this.$refs.select.open = false;
    },
    scheduledTimeHours: function (value) {
      this.appData.scheduledTimeHH = value;
    },
    scheduledTimeMinutes: function (value) {
      this.appData.scheduledTimeMin = value;
    }
  },
  created() {
    this.init();
    this.$root.$on('manpower_updated', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appData = this.dataObj;
        this.stationId = this.dataObj.stationId;
        this.allEmployees = this.appData.availableEmployees;
        this.scheduledTime.hours = this.appData.scheduledTimeHH;
        this.scheduledTime.minutes = this.appData.scheduledTimeMin;

        if (this.appData.employee && this.appData.employee.fullname.length === 0)
          this.appData.employee = '';
      });
    },
  },
}

